import { v4 as uuidv4 } from 'uuid';
import MultiSelectComponent from '../../../components/multi-select/multi-select.component';
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { codeMasterType } from "../../../config/constants";
import scheduleModel from "../../../models/schedule/jpo-schedule.model";
import ViewBase from "../../view-base.view";
import { Tooltip, PopoverPosition } from "construct-ui";
import 'CssFolder/schedule/jpo/jpo-report.scss';

export default function PlanActualWeeklyMonthly() {
    ViewBase.call(this)

    let imceTypeList = [];
    let userRoleList = [];
    let adminList = [];
    let userRoleListByFilter = [];
    let supervisorList = [];
    let displayPercentageList = [];
    let supervisorListByFilter = [];
    let storeGradeList = [];
    let siteGroupList = [];
    let tableData = [];

    let imceTypeOld = '';
    let initLoadData = false;
    let isAdmin = 0;
    let isSubsidiaryAdmin = 0;

    const DEFAULT_FILTERS = {
        storeGrades: [],
        siteGroups: [],
        imceType: {},
        userRole: {},
        supervisors: [],
    };
    let filters = structuredClone(DEFAULT_FILTERS);
    let oldFilters = structuredClone(filters);

    let inputDataModel = { storeGrades: "", siteGroups: "", BU: "", SupervisorRoles: "", SupervisorIds: "", };

    let getAdmin = () => {
        adminList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        adminList.push({ ...e });
                    });
                    isAdmin = adminList.filter(x => x.code == 'Admin' && x.mapData == 1).length > 0 ? 1 : 0;
                    isSubsidiaryAdmin = adminList.filter(x => x.code == 'SubsidiaryAdmin' && x.mapData == 1).length > 0 ? 1 : 0;
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SummaryRptAdmin',
            }
        )
    }

    const getStoreGradeList = () => {
        storeGradeList = [];
        return scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        storeGradeList.push({ ...e });
                    }); 
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: "StoreGrade",
                mapData: filters.imceType.code
            }
        )
    }

    let getSiteGroupList = () => {
        siteGroupList = [];
        return scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        siteGroupList.push({ ...e });
                    });
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: "SiteGroup",
            }
        )
    }

    const getImceTypeList = () => {
        imceTypeList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    imceTypeList = result;
                    filters.imceType = imceTypeList.length > 0 ? imceTypeList[0] : {};
                    imceTypeOld = filters.imceType.code;
                    getStoreGradeList();
                    getDisplayPercentage();
                    getUserRoleList();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: codeMasterType.bu,
            }
        )
    }

    let getUserRoleList = () => {
        userRoleList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        userRoleList.push({ ...e });
                    });
                    getUserRoleListByFilter();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SupervisorRole',
            }
        )
    }

    let getUserRoleListByFilter = () => {
        userRoleListByFilter = [];
        if (userRoleList) {
            userRoleListByFilter = userRoleList.filter(x => x.mapData == filters.imceType.code);
            
            if (userRoleListByFilter.length > 0) {
                filters.userRole = userRoleListByFilter[0];
                if (initLoadData) {
                    getSupervisorList();
                } else {
                    getSupervisorListByFilter();
                }
            }
        } else {
            getUserRoleList();
        }
    }

    let getSupervisorList = () => {
        supervisorList = [];
        this.showLoading();
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        supervisorList.push({ ...e });
                    });
                }
                getSupervisorListByFilter();
                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
                this.hideLoading();
            },
            {
                type: 'SupervisorOrLeadSupervisor',                
                mapData: userRoleList.map(i => i["code"]).join(',')
            }
        );
    }

    let getSupervisorListByFilter = () => {
        supervisorListByFilter = [];
        filters.supervisors = [];
        if (supervisorList) {
            supervisorListByFilter = supervisorList.filter(x => x.mapData == filters.userRole.code);
            if (initLoadData) {
                initLoadData = false;
                getSchedulePlanAndActualWeeklyMonthlyList();
            }
        } else {
            getSupervisorList();
        }
    }

    let getDisplayPercentage = () => {
        userRoleList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        displayPercentageList.push({ ...e });
                    });
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'DisplayPercentage',
                mapData: filters.imceType.code
            }
        )
    }

    const onSearch = (e) => {
        search();
    }

    let onClear = () => {
        filters.userRole = userRoleListByFilter[0];
        filters.supervisors = [];
        filters.siteGroups = [];
        filters.storeGrades = [];
        search();
    }

    let search = () => {
        getSchedulePlanAndActualWeeklyMonthlyList();
    }

    let getSchedulePlanAndActualWeeklyMonthlyList = () => {
        this.showLoading();
        return scheduleModel.getSchedulePlanAndActualWeeklyMonthlyList(
            (result) => {
                if (result != null) {
                    tableData = result;
                }
                else {
                    tableData = [];
                }
                
                oldFilters = structuredClone(filters);
                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
            },
            {
                StoreGrades: filters.storeGrades.map(i => i["code"]).join(','),
                //SiteGroups: filters.siteGroups.map(i => i["code"]).join(','),                    
                SiteGroups: '',
                BU: filters.imceType.code,
                SupervisorIds: filters.supervisors.map(i => i["code"]).join(','),
                SupervisorRoles: filters.userRole.code,
            }
        )
    }

    let _downloadExcel = () => {
        this.showLoading();
        var fileName = uuidv4();

        if (oldFilters) {
            if (oldFilters.storeGrades.length > 0) {
                inputDataModel.storeGrades = oldFilters.storeGrades.map(i => i["code"]).join(',');
            }
            else {
                inputDataModel.storeGrades = "";
            }
            if (oldFilters.imceType.code != "")
                inputDataModel.BU = oldFilters.imceType.code;
            else
                inputDataModel.BU = "";
            if (oldFilters.supervisors.length > 0)
                inputDataModel.SupervisorIds = oldFilters.supervisors.map(i => i["code"]).join(',');
            else
                inputDataModel.SupervisorIds = "";
            inputDataModel.SupervisorRoles = oldFilters.userRole.code;

            inputDataModel.siteGroups = "";
            /*if (filters.leadSupervisors.length > 0) {
                inputDataModel.LeadSupervisors = filters.leadSupervisors.map(i => i["code"]).join(',');
            }
            else {
                inputDataModel.LeadSupervisors = "";
            }*/
        }
        else {
            this.showErrorMessage(
                this.getText("", "Please select the filter."),
                this.getText("EM00000142", "Error")
            )
        }

        scheduleModel.jpoWeeklyMonthlyDownloadExcel(
            (result) => { this.hideLoading() },
            (error) => {
                this.hideLoading();
                this.handleError(error);
            },
            inputDataModel, fileName
        )
    }

    const getHeader = (tableData) => {
        const weekNames = [
            tableData?.beforeLastWeekName || "",
            tableData?.lastWeekName || "",
            tableData?.currentWeekName || "",
            tableData?.mtdMonthName || ""
        ];

        const monthNames = [
            tableData?.beforeLastMonthName || "",
            tableData?.lastMonthName || "",
            tableData?.currentMonthName || ""
        ];

        return m('tr.align-middle',
            m("th.jpo-border-left.sticky-col.sticky-col-wm-1", { "scope": "col", "rowspan": "2" }, this.getText("LT00008113", "Branch")),
            m("th.sticky-col.sticky-col-wm-2", { "scope": "col", "rowspan": "2" }, this.getText("LT00000271", "Supervisor")),

            weekNames.map((name) => m("th.text-center", { "scope": "col", "colspan": "3" }, this.getText("", name))),

            monthNames.map((name) => m("th.text-center", { "scope": "col", "colspan": "3" }, this.getText("", name)))
        )
    };

    const excellentScore = displayPercentageList.length > 0 ? displayPercentageList[0].code : 90;
    const goodScore = displayPercentageList.length > 0 ? displayPercentageList[1].code : 80;
    const getTdElement = (data) => {
        let cssClass;
        if (data >= excellentScore) {
            cssClass = "green-circle";
        }
        else if (data >= goodScore) {
            cssClass = "amber-circle";
        }
        else {
            cssClass = "red-circle";
        }

        return m('td.text-end',
            m('div', { "class": cssClass, "style": "display: inline-block;" }),
            m('span.cursor-text', " " + data + "%"));
    }

    const getLegend = () => {
        return m('.d-flex.align-items-center',

            m('span.badge.bg-success', { style: 'width: 30px; height: 20px; display: inline-block; margin-right: 5px;' }),
            m('span', displayPercentageList.length > 0 ? displayPercentageList[0].name : '>= 90'),
            m('span', { style: 'margin-left: 20px;' }),


            m('span.badge.bg-amber.text-dark', { style: 'width: 30px; height: 20px; display: inline-block; margin-right: 5px;' }),
            m('span', displayPercentageList.length > 0 ? displayPercentageList[1].name : '80 - 89'),
            m('span', { style: 'margin-left: 20px;' }),


            m('span.badge.jpo-bg-danger', { style: 'width: 30px; height: 20px; display: inline-block; margin-right: 5px;' }),
            m('span', displayPercentageList.length > 0 ? displayPercentageList[2].name : '< 80'),
        );
    };

    const getToolTipContent = (content) => {
        const arrContent = content.split('<br>');
        return m('div',
            arrContent.reduce((acc, item, index) => {
                acc.push(m('span', item));
                if (index < arrContent.length - 1) {
                    acc.push(m('br'));
                }
                return acc;
            }, [])
        );
    }

    const getTrigger = (trigger1, trigger2, trigger3) => {
        const triggers = [trigger1, trigger2, trigger3].filter(t => t != null);
        const cTrigger = triggers.flatMap((t, i) => [
            m('span', t),
            i < triggers.length - 1 ? m('br') : null
        ]);

        return m('div', cTrigger);
    }

    const getToolTips = (content, trigger1, trigger2, trigger3) => {

        return m(Tooltip, {
            content: getToolTipContent(content),
            hoverOpenDelay: 250,
            hoverCloseDelay: 250,
            openOnTriggerFocus: true,
            position: PopoverPosition.TOP,
            trigger: getTrigger(trigger1, trigger2, trigger3)
        })
    };

    return {
        oninit: () => {
            initLoadData = true;
            getAdmin();
            getImceTypeList();
            //getSiteGroupList(); 
        },
        oncreate: (vnode) =>{
            const updateColStickyStyle = () => {
                const firstColSticky = document.querySelector('.sticky-col-wm-1').offsetWidth
                const secondColSticky = document.querySelectorAll('.sticky-col-wm-2')
                secondColSticky.forEach(c => c.style.left = `${firstColSticky}px`);
            }
            updateColStickyStyle();

            vnode.state.updateColStickyStyle = updateColStickyStyle;
            window.addEventListener("resize",updateColStickyStyle)
        },
        onupdate:(vnode)=>{
            vnode.state.updateColStickyStyle?.();
        },
        onremove: (vnode) =>{
            window.removeEventListener("resize",vnode.state.updateColStickyStyle);
        },
        view: () => {
            return [
                // SEARCH
                m(".card.mb-3",
                    m(".card-body",
                        m('.row.g-4',
                            //m('.col-md-3',
                            //    m('label.form-label', this.getText("LT00008114", "Store Grade")),
                            //    m(MultiSelectComponent, {
                            //        items: storeGradeList,
                            //        selectedItems: filters.storeGrades,
                            //        onSelect: (s) => {
                            //            filters.storeGrades = s;
                            //        }
                            //    }),
                            //),
                            m(
                                ".col-md-3.col-lg-3.position-relative",
                                m("label.form-label", this.getText("LT00000817", "MX/CE Store")),
                                m(SingleSelectComponent, {
                                    id: "imce",
                                    items: imceTypeList,
                                    selectedItem: filters.imceType,
                                    checkmark: true,
                                    filterable: true,
                                    required: true,
                                    allowEmpty: false,
                                    onSelect: (s) => {
                                        if (imceTypeOld != s.code && s.code != '') {
                                            filters.imceType = s;
                                            filters.userRole = userRoleListByFilter[0];
                                            filters.supervisors = [];
                                            getUserRoleListByFilter();
                                            imceTypeOld = s.code;
                                        }
                                    },
                                })
                            ),
                            m('.col-md-3',
                                m('label.form-label', this.getText("LT00000060", "User Role")),
                                m(SingleSelectComponent, {
                                    items: userRoleListByFilter,
                                    selectedItem: filters.userRole,
                                    allowEmpty: false,
                                    onSelect: (s) => {
                                        filters.userRole = s;
                                        getSupervisorListByFilter();
                                    }
                                }),
                            ),
                            m('.col-md-3',
                                m('label.form-label', this.getText(isSubsidiaryAdmin == 1 ? "LT00008108" : "LT00000271", isSubsidiaryAdmin == 1 ? "Lead Supervisor" : "Supervisor")),
                                m(MultiSelectComponent, {
                                    items: supervisorListByFilter,
                                    selectedItems: filters.supervisors,
                                    onSelect: (s) => {
                                        filters.supervisors = s;
                                    }
                                }),
                            ),
                            /*m('.col-md-3',
                                m('label.form-label', this.getText("", "Site Group")),
                                m(MultiSelectComponent, {
                                    items: siteGroupList,
                                    selectedItems: filters.siteGroups,
                                    onSelect: (s) => {
                                        filters.siteGroups = s;
                                    }
                                }),
                            ),*/

                            /*
                            m('.col-md-3',
                                m('label.form-label', this.getText("Lead Supervisor")),
                                m(MultiSelectComponent, {
                                    items: leadSupervisorList,
                                    selectedItems: filters.leadSupervisors,
                                    onSelect: (s) => {
                                        filters.leadSupervisors = s;
                                    }
                                }),
                            ),*/
                            m(".col-xl-3.col-lg-6.d-flex.align-items-end.justify-content-start.gap-2",
                                m('button.btn.btn-primary',
                                    {
                                        onclick: () => {
                                            onSearch();
                                        },
                                    },
                                    this.getText("LT00000001", "Search")),

                                m('button.btn.btn-white', { onclick: onClear }, this.getText("LT00000031", "Clear")),
                            ),
                        ),
                    )
                ),
                // SEARCH - end

                // Table section
                m('.card',
                    m('.card-body',
                        m('.row.g-2 ',
                            m('.col-12.p-0',
                                m('.d-flex.justify-content-between.mb-2',
                                    getLegend(),

                                    m('a.btn.btn-primary', { onclick: _downloadExcel },
                                        m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                                    )
                                ),
                                m('.jpo-table-responsive',
                                    m('table.table.table-hover.align-middle',
                                        m('thead',

                                            getHeader(tableData)
                                            ,
                                            m("tr.text-center.light-header", { "class": "thead-bggrey align-middle " },

                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008125", "Number of Planned Stores Visit Count"),
                                                        this.getText("LT00008115", "Plan"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008126", "Number of Actual Stores Visited Count"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008127", "(Number of Actual Stores Visited Count / Number of Planned Stores Visit Count) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008125", "Number of Planned Stores Visit Count"),
                                                        this.getText("LT00008115", "Plan"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008126", "Number of Actual Stores Visited Count"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008127", "(Number of Actual Stores Visited Count / Number of Planned Stores Visit Count) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008125", "Number of Planned Stores Visit Count"),
                                                        this.getText("LT00008115", "Plan"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008126", "Number of Actual Stores Visited Count"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008127", "(Number of Actual Stores Visited Count / Number of Planned Stores Visit Count) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008125", "Number of Planned Stores Visit Count"),
                                                        this.getText("LT00008115", "Plan"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008126", "Number of Actual Stores Visited Count"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008127", "(Number of Actual Stores Visited Count / Number of Planned Stores Visit Count) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008125", "Number of Planned Stores Visit Count"),
                                                        this.getText("LT00008115", "Plan"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008126", "Number of Actual Stores Visited Count"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008127", "(Number of Actual Stores Visited Count / Number of Planned Stores Visit Count) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008125", "Number of Planned Stores Visit Count"),
                                                        this.getText("LT00008115", "Plan"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008126", "Number of Actual Stores Visited Count"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008127", "(Number of Actual Stores Visited Count / Number of Planned Stores Visit Count) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008125", "Number of Planned Stores Visit Count"),
                                                        this.getText("LT00008115", "Plan"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008126", "Number of Actual Stores Visited Count"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th", { "scope": "col", "style": "text-align: right !important;" },
                                                    getToolTips(this.getText("LT00008127", "(Number of Actual Stores Visited Count / Number of Planned Stores Visit Count) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),
                                            ),
                                        ),
                                        m('tbody',
                                            (tableData == null || tableData.wmDetails == null || tableData.wmDetails.length == 0) &&
                                            m('tr.align-middle',
                                                m('td[colSpan=25]', this.getText("EM00000141", "No records found."))
                                            ),
                                            (tableData != null && tableData.wmDetails != null && tableData.wmDetails.length > 0) &&
                                            tableData.wmDetails.map((data) =>
                                                m('tr.align-middle',

                                                    m('td.sticky-col.sticky-col-wm-1', m('span.cursor-text', data.branch)),
                                                    m('td.sticky-col.sticky-col-wm-2', m('span.cursor-text', data.userName)),

                                                    m('td.text-end', m('span.cursor-text', data.week_2_Plan)),
                                                    m('td.text-end', m('span.cursor-text', data.week_2_Actual)),
                                                    getTdElement(data.week_2_Pct)
                                                    ,

                                                    m('td.text-end', m('span.cursor-text', data.week_1_Plan)),
                                                    m('td.text-end', m('span.cursor-text', data.week_1_Actual)),
                                                    getTdElement(data.week_1_Pct),


                                                    m('td.text-end', m('span.cursor-text', data.week_0_Plan)),
                                                    m('td.text-end', m('span.cursor-text', data.week_0_Actual)),
                                                    getTdElement(data.week_0_Pct),


                                                    m('td.text-end', m('span.cursor-text', data.month_Mtd_Plan)),
                                                    m('td.text-end', m('span.cursor-text', data.month_Mtd_Actual)),
                                                    getTdElement(data.month_Mtd_Pct),

                                                    m('td.text-end', m('span.cursor-text', data.month_2_Plan)),
                                                    m('td.text-end', m('span.cursor-text', data.month_2_Actual)),
                                                    getTdElement(data.month_2_Pct),


                                                    m('td.text-end', m('span.cursor-text', data.month_1_Plan)),
                                                    m('td.text-end', m('span.cursor-text', data.month_1_Actual)),
                                                    getTdElement(data.month_1_Pct),


                                                    m('td.text-end', m('span.cursor-text', data.month_0_Plan)),
                                                    m('td.text-end', m('span.cursor-text', data.month_0_Actual)),
                                                    getTdElement(data.month_0_Pct),



                                                )
                                            ),
                                            (tableData != null && tableData.wmTotal != null && tableData.wmDetails.length > 0) &&
                                            m('tr.align-middle',

                                                m('td.text-center.sticky-col.sticky-col-wm-1', { "colspan": "2" }, m('span.cursor-text', "Grand Total")),

                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.week_2_Plan)),
                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.week_2_Actual)),
                                                getTdElement(tableData.wmTotal.week_2_Pct),


                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.week_1_Plan)),
                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.week_1_Actual)),
                                                getTdElement(tableData.wmTotal.week_1_Pct),


                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.week_0_Plan)),
                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.week_0_Actual)),
                                                getTdElement(tableData.wmTotal.week_0_Pct),


                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_Mtd_Plan)),
                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_Mtd_Actual)),
                                                getTdElement(tableData.wmTotal.month_Mtd_Pct),

                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_2_Plan)),
                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_2_Actual)),
                                                getTdElement(tableData.wmTotal.month_2_Pct),

                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_1_Plan)),
                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_1_Actual)),
                                                getTdElement(tableData.wmTotal.month_1_Pct),


                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_0_Plan)),
                                                m('td.text-end', m('span.cursor-text', tableData.wmTotal.month_0_Actual)),
                                                getTdElement(tableData.wmTotal.month_0_Pct),



                                            )
                                        )
                                    ),

                                ),
                                //Paging
                            )
                        )
                    )
                ),
                // Table section - end
                this.getBaseViews()
            ];
        }
    }
}